import React from "react";
import { Link } from "react-router";
import ReactDataSheet from "react-datasheet";
import FirebaseApi from "../../api/firebase";

import { year_wages, brp_bonus_wages } from "../home/wages";
import {
  year_2018_proportions_new,
  year_2018_proportions,
  headship_hours,
} from "../home/restrictions.js";
import { glosary, glosary_abreviations } from "../home/glosary";
import Select from "react-select";

import ReactHTMLTableToExcel from "react-html-table-to-excel";

class ETL_minutes extends React.Component {
  constructor(props) {
    super(props);
    //this.state = props.contractInfo
    this.state = {
      loading: false,
      year: "",
      exportData: [],
    };
  }

  processContract = (contractInfo, key) => {
    let processedContract = {
      ...contractInfo,
      id: key,
    };
    return processedContract;
  };
  startETL = () => {
    const { year } = this.state;
    if (!year) return;

    let contracts = [];

    FirebaseApi.GetValues("/contracts").then((snap) => {
      let contractsObj = snap.val();
      if (!contractsObj) return;

      Object.keys(contractsObj).forEach((key) => {
        const c = contractsObj[key];

        // "01-08-2014" → ["01","08","2014"]
        const contractYear = c.contractDate.split("-")[2];

        if (Number(contractYear) >= Number(year)) {
          contracts.push(this.processContract(c, key));
        }
      });

      this.setState({ contracts, loading: false });
      this.transformData(contracts);
    });
  };

  transformData = (contracts) => {
    let exportData = [];
    contracts.forEach((contract) => {
      let currentTeacher = {
        name: contract.name,
        school: contract.selectedOption.label,
        rut: contract.teacher ? contract.teacher.rut : null,
        start_date: contract.teacher ? contract.teacher.start_date : null,
        bonuses: contract ? contract.bonuses : null,
        headship: contract.headship ? contract.headship.label : null,
      };
      currentTeacher.categories_minutes = contract.categories_minutes;
      currentTeacher.signing_date = contract.signing_date;
      currentTeacher.total_minutes_final = contract.total_minutes_final;
      //console.log(currentTeacher);
      exportData.push(currentTeacher);
    });
    this.setState({ exportData: exportData });
  };

  myToFixed = (val) => {
    return parseFloat(val.toFixed(2));
  };
  handleYearChange = (selectedOption) => {
    this.setState({ year: selectedOption.value, loading: true }, () =>
      this.startETL()
    );
  };

  hourCounterSection = (key, minutes) => {
    return (
      <div>
        <td style={{ padding: "0 10px 0 10px" }}>
          {this.myToFixed(minutes / 60)}
        </td>
        <td style={{ padding: "0 10px 0 10px" }}>
          {this.myToFixed(minutes / 45)}
        </td>
      </div>
    );
  };

  generateYearDropdownOptions = () => {
    let ret = [];
    for (let i = new Date().getFullYear(); i > 2017; i--) {
      ret.push({ value: i, label: i });
    }
    return ret;
  };

  render() {
    return (
      <div className="jumbotron">
        <div className="flex">
          <h1>Exportando Base de datos</h1>
          <div
            className="title-spinner"
            style={
              this.state.loading ? { display: "flex" } : { display: "none" }
            }
          >
            <i
              className="fas fa-circle-notch fa-spin fa-2x"
              aria-hidden="true"
            ></i>
          </div>
        </div>
        <div className="form-group w-25">
          <label>Sacar contratos desde año:</label>
          <Select
            name="year"
            value={this.state.year}
            onChange={this.handleYearChange}
            options={this.generateYearDropdownOptions()}
            placeholder="Seleccionar año"
          />
        </div>

        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="download-table-xls-button btn btn-success"
          table="table-to-xls"
          filename="table"
          sheet="tablexls"
          buttonText="Descargar XLS"
        />
        <div className="scroll-x">
          <table
            id="table-to-xls"
            style={{ border: "solid 1px", margin: "10px 0 0 0" }}
          >
            <tr>
              <th style={{ padding: "0 10px 0 10px" }}>Nombre</th>
              <th style={{ padding: "0 10px 0 10px" }}>Rut</th>
              <th style={{ padding: "0 10px 0 10px" }}>Fecha Ingreso</th>
              <th style={{ padding: "0 10px 0 10px" }}>Colegio</th>
              <th style={{ padding: "0 10px 0 10px" }}>Fecha de Contrato</th>
              <th style={{ padding: "0 10px 0 10px" }}>Brp Mencion</th>
              <th style={{ padding: "0 10px 0 10px" }}>Brp Titulo</th>
              <th style={{ padding: "0 10px 0 10px" }}>Jefatura</th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Aula Basica Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Aula Basica Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Aula Media Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Aula Media Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Flotancia Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Flotancia Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas SEP 1 Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas SEP 1 Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas SEP 1 No en horario Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas SEP 1 No en horario Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas SEP 2 Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas SEP 2 Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas SEP 3 Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas SEP 3 Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas PIE Basica Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas PIE Basica Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas PIE Media Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas PIE Media Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas no lectivas Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas no lectivas Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Complementarias Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Complementarias Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Recre docente Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Recre docente Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Turno de patio Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Turno de patio Pedagogicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>Suma Cronologicas</th>
              <th style={{ padding: "0 10px 0 10px" }}>Suma Pedagogicas</th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Totales Cronologicas
              </th>
              <th style={{ padding: "0 10px 0 10px" }}>
                Horas Totales Pedagogicas
              </th>
            </tr>
            {this.state.exportData.map((teacher, index) => (
              <tr key={index}>
                <td style={{ padding: "0 10px 0 10px" }}>{teacher.name}</td>
                <td style={{ padding: "0 10px 0 10px" }}>{teacher.rut}</td>
                <td style={{ padding: "0 10px 0 10px" }}>
                  {teacher.start_date}
                </td>
                <td style={{ padding: "0 10px 0 10px" }}>{teacher.school}</td>
                <td style={{ padding: "0 10px 0 10px" }}>
                  {teacher.signing_date}
                </td>
                <td style={{ padding: "0 10px 0 10px" }}>
                  {teacher.bonuses
                    ? teacher.bonuses.brp_mencion
                      ? "Si"
                      : "No"
                    : "No"}
                </td>
                <td style={{ padding: "0 10px 0 10px" }}>
                  {teacher.bonuses
                    ? teacher.bonuses.brp_titulo
                      ? "Si"
                      : "No"
                    : "No"}
                </td>
                <td style={{ padding: "0 10px 0 10px" }}>{teacher.headship}</td>
                {this.hourCounterSection(
                  "middle_classroom",
                  teacher.categories_minutes["middle_classroom"]
                )}
                {this.hourCounterSection(
                  "high_classroom",
                  teacher.categories_minutes["high_classroom"]
                )}
                {this.hourCounterSection(
                  "float",
                  teacher.categories_minutes["float"]
                )}
                {this.hourCounterSection(
                  "sep_1",
                  teacher.categories_minutes["sep_1"]
                )}
                {this.hourCounterSection(
                  "non_visible_sep_1",
                  teacher.categories_minutes["non_visible_sep_1"]
                )}
                {this.hourCounterSection(
                  "sep_2",
                  teacher.categories_minutes["sep_2"]
                )}
                {this.hourCounterSection(
                  "sep_3",
                  teacher.categories_minutes["sep_3"]
                )}
                {this.hourCounterSection(
                  "pie_middle_classroom",
                  teacher.categories_minutes["pie_middle_classroom"]
                )}
                {this.hourCounterSection(
                  "pie_high_classroom",
                  teacher.categories_minutes["pie_high_classroom"]
                )}
                {this.hourCounterSection(
                  "non_academic",
                  teacher.categories_minutes["non_academic"]
                )}
                {this.hourCounterSection(
                  "colab",
                  teacher.categories_minutes["colab"]
                )}
                {this.hourCounterSection(
                  "break",
                  teacher.categories_minutes["break"]
                )}
                {this.hourCounterSection(
                  "yard_turn",
                  teacher.categories_minutes["yard_turn"]
                )}
                <td>
                  {this.myToFixed(
                    Object.values(teacher.categories_minutes).reduce(
                      (a, b) => a + b
                    ) / 60
                  )}
                </td>
                <td>
                  {this.myToFixed(
                    Object.values(teacher.categories_minutes).reduce(
                      (a, b) => a + b
                    ) / 45
                  )}
                </td>
                <td>{this.myToFixed(teacher.total_minutes_final / 60)}</td>
                <td>{this.myToFixed(teacher.total_minutes_final / 45)}</td>
              </tr>
            ))}
          </table>
        </div>
      </div>
    );
  }
}

export default ETL_minutes;



// WEBPACK FOOTER //
// ./src/components/BI/ETL-categories-minutes.js